module.exports = "/_next/static/images/warranty-promo-horiz-7551f3ce6fb95ea311eaa88967b1b465.png";